<script>
    export let graph;

    let playerVisible = false;    
    //let playerVisible = true;
    let imageVisible = false;
    let imageId = false;
    //let videoMuxId = "SqVsEem79FBf01Fq6NrX8Ihxe1mfX7oVq";
    let videoMuxId = "";
    let progress = null;

    const image = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='48' height='48' viewBox='0 0 172 172' style=' fill:%23000000;'%3E%3Cg fill='none' fill-rule='nonzero' stroke='none' stroke-width='1' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='10' stroke-dasharray='' stroke-dashoffset='0' font-family='none' font-weight='none' font-size='none' text-anchor='none' style='mix-blend-mode: normal'%3E%3Cpath d='M0,172v-172h172v172z' fill='none'%3E%3C/path%3E%3Cpath d='M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86v0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z' fill='white'%3E%3C/path%3E%3Cg fill='%231d120c'%3E%3Cpath d='M86,44.43333c-41.56667,0 -57.15417,41.56667 -57.15417,41.56667c0,0 15.5875,41.56667 57.15417,41.56667c41.56667,0 57.15417,-41.56667 57.15417,-41.56667c0,0 -15.5875,-41.56667 -57.15417,-41.56667zM86,60.02083c14.3457,0 25.97917,11.63347 25.97917,25.97917c0,14.3457 -11.63347,25.97917 -25.97917,25.97917c-14.3457,0 -25.97917,-11.63347 -25.97917,-25.97917c0,-14.3457 11.63347,-25.97917 25.97917,-25.97917zM86,70.4125c-8.60874,0 -15.5875,6.97876 -15.5875,15.5875c0,8.60874 6.97876,15.5875 15.5875,15.5875c8.60874,0 15.5875,-6.97876 15.5875,-15.5875c0,-8.60874 -6.97876,-15.5875 -15.5875,-15.5875z'%3E%3C/path%3E%3C/g%3E%3Cpath d='M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86v0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z' fill='none'%3E%3C/path%3E%3Cpath d='M86,168.56c-45.59663,0 -82.56,-36.96337 -82.56,-82.56v0c0,-45.59663 36.96337,-82.56 82.56,-82.56v0c45.59663,0 82.56,36.96337 82.56,82.56v0c0,45.59663 -36.96337,82.56 -82.56,82.56z' fill='none'%3E%3C/path%3E%3C/g%3E%3C/svg%3E";
    const digits = {
        1: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iNDgiIGhlaWdodD0iNDgiCnZpZXdCb3g9IjAgMCAxNzIgMTcyIgpzdHlsZT0iIGZpbGw6IzAwMDAwMDsiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJidXR0IiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1kYXNoYXJyYXk9IiIgc3Ryb2tlLWRhc2hvZmZzZXQ9IjAiIGZvbnQtZmFtaWx5PSJub25lIiBmb250LXdlaWdodD0ibm9uZSIgZm9udC1zaXplPSJub25lIiB0ZXh0LWFuY2hvcj0ibm9uZSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOiBub3JtYWwiPjxwYXRoIGQ9Ik0wLDE3MnYtMTcyaDE3MnYxNzJ6IiBmaWxsPSJub25lIj48L3BhdGg+PGcgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTg2LDE0LjMzMzMzYy0zOS40MTY2NywwIC03MS42NjY2NywzMi4yNSAtNzEuNjY2NjcsNzEuNjY2NjdjMCwzOS40MTY2NyAzMi4yNSw3MS42NjY2NyA3MS42NjY2Nyw3MS42NjY2N2MzOS40MTY2NywwIDcxLjY2NjY3LC0zMi4yNSA3MS42NjY2NywtNzEuNjY2NjdjMCwtMzkuNDE2NjcgLTMyLjI1LC03MS42NjY2NyAtNzEuNjY2NjcsLTcxLjY2NjY3ek05NS4zMTY2NywxMTguOTY2NjdoLTEyLjl2LTUwLjg4MzMzbC0xNS43NjY2Nyw1LjAxNjY3di0xMC43NWwyNy4yMzMzMywtMTAuMDMzMzNoMS40MzMzM3oiPjwvcGF0aD48L2c+PC9nPjwvc3ZnPg==",
        2: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iNjQiIGhlaWdodD0iNjQiCnZpZXdCb3g9IjAgMCAxNzIgMTcyIgpzdHlsZT0iIGZpbGw6IzAwMDAwMDsiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJidXR0IiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1kYXNoYXJyYXk9IiIgc3Ryb2tlLWRhc2hvZmZzZXQ9IjAiIGZvbnQtZmFtaWx5PSJub25lIiBmb250LXdlaWdodD0ibm9uZSIgZm9udC1zaXplPSJub25lIiB0ZXh0LWFuY2hvcj0ibm9uZSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOiBub3JtYWwiPjxwYXRoIGQ9Ik0wLDE3MnYtMTcyaDE3MnYxNzJ6IiBmaWxsPSJub25lIj48L3BhdGg+PGcgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTg2LDE0LjMzMzMzYy0zOS40MTY2NywwIC03MS42NjY2NywzMi4yNSAtNzEuNjY2NjcsNzEuNjY2NjdjMCwzOS40MTY2NyAzMi4yNSw3MS42NjY2NyA3MS42NjY2Nyw3MS42NjY2N2MzOS40MTY2NywwIDcxLjY2NjY3LC0zMi4yNSA3MS42NjY2NywtNzEuNjY2NjdjMCwtMzkuNDE2NjcgLTMyLjI1LC03MS42NjY2NyAtNzEuNjY2NjcsLTcxLjY2NjY3ek0xMDkuNjU1NiwxMTguOTc3ODdoLTQ1Ljg4MzQ2di05LjMyMjI3YzE5LjM3MjQsLTIxLjUgMzAuMTIyNCwtMjkuMzk0NTMgMzAuMTIyNCwtMzcuOTg4OTNjMCwtMi44NTU0NyAtMS40NTU3MywtOS4zMjIyNiAtOC42MjI0LC05LjMyMjI2Yy05LjI5NDI3LDAgLTkuMjk0MjcsOS4zMjIyNiAtOS4yOTQyNywxMS40Nzc4NmgtMTMuNjMzNDdjMCwtNi40NjY3OSA1LjAxMTA3LC0yMS41IDIyLjkyNzc0LC0yMS41YzE3LjkxNjY3LDAgMjEuNSwxMC43NSAyMS41LDE4LjYxNjU0YzAsMTAuNzUgLTcuODY2NTQsMTkuMzcyNCAtMjYuNTExMDcsMzcuOTg4OTNoMjguNjY2Njd2MTAuMDUwMTN6Ij48L3BhdGg+PC9nPjwvZz48L3N2Zz4=",
        3: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iNjQiIGhlaWdodD0iNjQiCnZpZXdCb3g9IjAgMCAxNzIgMTcyIgpzdHlsZT0iIGZpbGw6IzAwMDAwMDsiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIHN0cm9rZS1saW5lY2FwPSJidXR0IiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1kYXNoYXJyYXk9IiIgc3Ryb2tlLWRhc2hvZmZzZXQ9IjAiIGZvbnQtZmFtaWx5PSJub25lIiBmb250LXdlaWdodD0ibm9uZSIgZm9udC1zaXplPSJub25lIiB0ZXh0LWFuY2hvcj0ibm9uZSIgc3R5bGU9Im1peC1ibGVuZC1tb2RlOiBub3JtYWwiPjxwYXRoIGQ9Ik0wLDE3MnYtMTcyaDE3MnYxNzJ6IiBmaWxsPSJub25lIj48L3BhdGg+PGcgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTg2LDE0LjMzMzMzYy0zOS40MTY2NywwIC03MS42NjY2NywzMi4yNSAtNzEuNjY2NjcsNzEuNjY2NjdjMCwzOS40MTY2NyAzMi4yNSw3MS42NjY2NyA3MS42NjY2Nyw3MS42NjY2N2MzOS40MTY2NywwIDcxLjY2NjY3LC0zMi4yNSA3MS42NjY2NywtNzEuNjY2NjdjMCwtMzkuNDE2NjcgLTMyLjI1LC03MS42NjY2NyAtNzEuNjY2NjcsLTcxLjY2NjY3ek04NS4yNzIxNCwxMTkuNjc3NzRjLTE3LjE4ODgxLDAgLTIyLjkyNzc0LC0xMi4xNzc3NCAtMjIuMTk5ODgsLTE5LjM0NDRoMTIuOTA1NmMtMC43Mjc4NywyLjE1NTYgMS40Mjc3Myw4LjU5NDQgMTAuMDIyMTMsOC41OTQ0YzkuMzIyMjYsMCAxMC4wMjIxNCwtNy44NjY1MyAxMC4wMjIxNCwtOS4zMjIyNmMwLC0xMC4wMjIxNCAtOS4yOTQyNywtMTAuMDIyMTQgLTEwLjc1LC0xMC4wMjIxNGgtNy4xNjY2N3YtMTAuMDIyMTNoNy4xNjY2N2MzLjU4MzMzLDAgMTAuMDUwMTIsLTAuNzI3ODcgMTAuMDUwMTIsLTkuMzIyMjdjMCwtNy44OTQ1MyAtNy4xNjY2NywtOC41OTQ0IC05LjMyMjI2LC04LjU5NDRjLTcuMTY2NjcsMCAtOC41OTQ0LDUuNzEwOTQgLTguNTk0NCw3LjE2NjY3aC0xMy42MzM0NmMwLC0xMi45MDU2IDEyLjkwNTYsLTE3LjkxNjY3IDIxLjUsLTE3LjkxNjY3YzIwLjA3MjI2LDAgMjIuMjI3ODYsMTMuNjA1NDcgMjIuMjI3ODYsMTguNjE2NTNjMCw5LjMyMjI2IC04LjU5NDQsMTMuNjMzNDcgLTEwLjAyMjEzLDE0LjMzMzMzYzMuNTgzMzMsMS40Mjc3NCAxMC43NSw1LjAxMTA3IDEwLjc1LDE1Ljc2MTA3YzAuNjk5ODcsMTUuNzg5MDYgLTEyLjkwNTYsMjAuMDcyMjYgLTIyLjk1NTczLDIwLjA3MjI2eiI+PC9wYXRoPjwvZz48L2c+PC9zdmc+",
    }    

    // https://github.com/pchen66/panolens.js/issues/35
    function setGaze (viewer, target) {
        /**
        * Set line of sight for panolens camera.
        *
        * Panolens uses `THREE.OrbitControls` as a way to control the camera
        * so normal `THREE.PerspectiveCamera.rotation` does NOT work.
        *
        * @param  {THREE.Vector} target - Target to look at.
        */
        const { x, y, z } = target.normalize();
        viewer.camera.position.set(x, -y, -z);
    }

    function onProgress ( event ) {
        progress = event.progress.loaded / event.progress.total * 100;
        if (progress >= 100) {
            progress = null;
        }
    }

    function handleRequestClosePlayer() {
        playerVisible = false;
    }
    function handleRequestCloseImage() {
        imageVisible = false;
    }

    function onEnter ( event ) {
        progress = 0;
      }

    let viewer;

    import { onMount, onDestroy } from 'svelte';
    import { getContext } from 'svelte';    
    import Player from './Player.svelte';
    import Modal from './Modal.svelte';
    import Image from './Image.svelte';

    const showContent = (spot) => {
        if (spot.show.image !== undefined) {
            imageVisible = true;
            imageId = `/${spot.show.image}`;
        }
        else {
            playerVisible = true;
            videoMuxId = spot.show.film;
        }           
    };

    onMount(async () => {        
        console.log('creating the viewer');
        mixpanel.track(
            "Viewer Loaded"
        );
        
        const panos = {};
        Object.entries(graph).forEach(([id, def]) => {
            const pano = new PANOLENS.ImagePanorama(def.url);
            pano.addEventListener( 'progress', onProgress );
            pano.addEventListener( 'enter', onEnter );

            for (const spot of def.spots) {
                // a link to another page

                if (spot.goto) {
                    pano.link(
                        () => {
                            mixpanel.track(
                                "Navigation",
                                {spot}
                            );
                            
                            return panos[spot.goto]
                        },
                        new THREE.Vector3(...spot.coords),
                        350,
                        spot.digit ? digits[spot.digit] : undefined
                    )
                }

                else {
                    let infospot = new PANOLENS.Infospot( 300, image );
                    infospot.position.set( ...spot.coords );
                    infospot.addEventListener( 'click', function() {
                        mixpanel.track(
                            "Clicked Spot",
                            {spot}
                        );

                      showContent(spot);
                    });
                    pano.add(infospot);
                }        
            }

            pano.addEventListener( 'enter-fade-start', function() {
                if (def.initialView) {
                    viewer.tweenControlCenter( new THREE.Vector3(...def.initialView), 3000 );
                    //setGaze(viewer, new THREE.Vector3(...def.initialView));
                }
              //viewer.tweenControlCenter( lookAtPositions[0], 0 );
            });            

            panos[id] = pano;
        });

    
        viewer = new PANOLENS.Viewer({
            output: 'console',  // PRINT position in ctrl + click
            autoHideInfospot: false, 
            cameraFov: 100,
        });
        viewer.add( ...Object.values(panos));

        // // Create a texture loader so we can load our image file
        // var loader = new THREE.TextureLoader();

        // // Load an image file into a custom material
        // var material = new THREE.MeshBasicMaterial({
        //     map: loader.load('https://s3.amazonaws.com/duhaime/blog/tsne-webgl/assets/cat.jpg')
        // });
        // var mesh = new THREE.Mesh(new THREE.BoxGeometry(30, 30, 30), material);
        // mesh.position.set(150, 0, 100)
        // panos['entrance'].add(mesh);


        // var geometry = new THREE.PlaneGeometry( 8, 20, 5 );
        // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
        // var plane = new THREE.Mesh( geometry, material );
        // plane.position.set(-25, 2 /* height */, -5)
        // plane.rotation.x = 80;
        // plane.rotation.y = 80;
        // plane.rotation.z = -0.10;
        // // viewer.addUpdateCallback(() => {
        // //     plane.rotation.z += 0.01;
        // //     console.log(plane.rotation.z)
        // // })
        // panos['center'].add(plane);




        // var cube = new THREE.Mesh(new THREE.BoxGeometry(30, 30, 30), new THREE.MeshNormalMaterial());
        // cube.position.set(-320 /* into fov */ , -100 /*height*/, 100 /* left/right */);
        // panos['entrance'].add( cube );


        // By default, zoom out a little.
        //viewer.getControl().dollyIn(5);        
        // const c = viewer.getControl();
        // c.object.fov = 100;
        // c.object.updateProjectionMatrix();
    });

    onDestroy(() => {
            console.log('disposing the viewer')
            viewer.destroy();   
            document.querySelector('.panolens-container').remove()
    })
</script>



<style>
    html, body {
        padding: 0;
        margin: 0;
    }

    #progress {
        width: 0;
        height: 5px;
        position: fixed;
        top: 0;
        background: rgb(76, 117, 250);
        -webkit-transition: opacity 0.5s ease;
        transition: opacity 0.5s ease;
      }

      #progress.finish {
        opacity: 0;
      }    

    :global(.ImageModalContainer) {
        display: flex;
        align-items: center;
    }
</style>

{#if progress !== null }
<div id="progress" style="width: {progress}%"></div>
{/if}


{#if playerVisible}
<Player onRequestClose={handleRequestClosePlayer} muxVideoId={videoMuxId} />
{/if}

{#if imageVisible}
<Modal on:requestclose={handleRequestCloseImage} closeVisible={true} className={"ImageModalContainer"}>
    <Image image={imageId} />
</Modal>
{/if}